export const routes = {
  ROOT: '/',
  DASHBOARD: '/dashboard',
  /*
   * This dashboard route captures all the params nested with in the dashboard route
   * This is the main route for the dashboard
   * It captures the region, tab, propertyDeckardId and propertyDetailsTab
   */
  DASHBOARD_ROUTE: '/:region/:tab?/:propertyDeckardId?/:propertyDetailsTab?',
  LOGIN: '/login',
  PROFILE: '/profile',
  MAP: '/home',
  LEGAL: '/legal',
  LOGOUT: '/logout',
};

export const nonCityRoutes = [routes.LOGIN, routes.LOGOUT];
